import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=6efa7443"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=6efa7443&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6efa7443')) {
      api.createRecord('6efa7443', component.options)
    } else {
      api.reload('6efa7443', component.options)
    }
    module.hot.accept("./VerticalNavMenu.vue?vue&type=template&id=6efa7443", function () {
      api.rerender('6efa7443', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vertical-nav-menu/VerticalNavMenu.vue"
export default component.exports